// User API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
export const DELETE_ACCOUNT_API = '/users/user/delete-account'; // userId
export const VERIFY_EMAIL_API = '/users/verify-email-address'; // userId

// Contact forms API
export const SUBMIT_CONTACT_FORM_API = '/contact/create-new-contact-form'; 
export const GET_ALL_CONTACT_FROMS_API = '/contact/get-all-contact-forms'; 
export const DELETE_CONTACT_FORM_API = '/contact/delete-contact-form'; 
export const DELETE_ALL_CONTACT_FORM_API = '/contact/delete-all-contact-forms'; 


